import styled from 'styled-components'

export default styled.a`
  background: #32F095;
  border: 0
  border-radius: 50px
  color: #121727
  cursor: pointer
  display: inline-flex
    align-items: center
  font-family: inherit
  font-size: 1.375rem
  font-weight: 700
  letter-spacing: 0.1em
  line-height: 1
  margin: 0 auto 2.5rem;
  padding: 1.25rem 2.5rem
  text-decoration: none;
  text-transform: uppercase;
  transition: all .35s ease;
  :hover {
    background: #fff
  }
  @media screen and (min-width: 1000px) {
    & {
      margin: 0 0 2.5rem;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/buyticketsbutton.js